import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader } from '../components/ui/card';

const Naissance = () => {
  const packages = [
    {
      name: 'SÉANCE BOUT\'CHOU',
      price: '279€',
      features: [
        '15 PHOTOS',
        '2 DÉCORS AU CHOIX',
        'PORTRAIT BÉBÉ'
      ]
    },
    {
      name: 'SÉANCE À CROQUER',
      price: '329€',
      features: [
        '20 PHOTOS',
        '3 DÉCORS AU CHOIX',
        'PORTRAIT BÉBÉ'
      ],
      popular: true
    },
    {
      name: 'SÉANCE DOUCEUR',
      price: '369€',
      features: [
        '30 PHOTOS',
        '3 DÉCORS',
        'PORTRAIT BÉBÉ ET DES PORTRAITS EN FAMILLE'
      ]
    }
  ];

  return (
    <div className="bg-[#FAF8F5]">
      {/* Hero Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="font-heading text-4xl md:text-5xl font-semibold text-[#6B5845] mb-4">
              Séances Photo Naissance
            </h1>
            <p className="font-heading text-xl text-[#8B7355]">
              Capturez la magie des premiers jours de votre bébé
            </p>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-6 max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-[#6B5845]">
              Photographe Grossesse, Naissance & Famille en Alsace – Strasbourg & Haguenau
            </h2>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Vous attendez un heureux événement ? Vous souhaitez immortaliser les premiers jours de votre bébé ou vivre une belle expérience photo en famille ? Je vous accueille dans mon studio photo cosy en Alsace, à proximité de Strasbourg et Haguenau, pour des séances remplies d'émotion et de tendresse.
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Spécialisée en photographie de maternité, de naissance et de famille depuis plus de neuf ans, je capture avec douceur vos moments les plus précieux : un ventre qui s'arrondit, un nouveau-né tout juste arrivé, ou l'amour spontané d'une famille réunie.
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Mon studio chaleureux et entièrement équipé (table à langer, chauffe-biberon, accessoires pour nouveau-né…) est conçu pour le bien-être des parents et de leurs bébés. Je prends le temps nécessaire pour que chaque séance se déroule en toute sérénité, dans une ambiance douce et bienveillante.
            </p>
            <p className="font-body text-base text-[#8B7355] leading-relaxed">
              Séance grossesse en Alsace, shooting nouveau-né à Strasbourg, ou séance famille près de Haguenau : je vous accompagne à chaque étape de cette belle aventure qu'est la parentalité. Mon objectif est de vous offrir des souvenirs authentiques et intemporels, que vous chérirez toute votre vie.
            </p>
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#6B5845] mb-4">
              Nos Forfaits Naissance
            </h2>
            <p className="font-body text-base text-[#8B7355]">
              Choisissez la formule qui vous correspond
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {packages.map((pkg, index) => (
              <Card 
                key={index} 
                className={`relative bg-white border-2 service-card ${
                  pkg.popular ? 'border-[#8B7355] shadow-xl' : 'border-[#E8DCC8]'
                }`}
              >
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-[#8B7355] text-white px-4 py-1 rounded-full text-sm font-body font-medium">
                      Plus populaire
                    </span>
                  </div>
                )}
                <CardHeader className="text-center pb-6 pt-8">
                  <h3 className="font-heading text-xl font-semibold text-[#6B5845] mb-2">
                    {pkg.name}
                  </h3>
                  <div className="font-heading text-4xl font-bold text-[#8B7355]">
                    {pkg.price}
                  </div>
                </CardHeader>
                <CardContent className="space-y-4">
                  {pkg.features.map((feature, i) => (
                    <div key={i} className="flex items-start space-x-3">
                      <Check size={20} className="text-[#8B7355] flex-shrink-0 mt-0.5" />
                      <span className="font-body text-sm text-[#6B5845]">{feature}</span>
                    </div>
                  ))}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#F5EDE4] rounded-lg p-8 md:p-12 text-center space-y-6">
            <h3 className="font-heading text-2xl md:text-3xl font-semibold text-[#6B5845]">
              Réservez votre séance photo naissance entre 5 et 20 jours de vie
            </h3>
            <p className="font-body text-base text-[#6B5845] leading-relaxed max-w-3xl mx-auto">
              Je mets à disposition l'ensemble des tenues et accessoires pour bébé !
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed max-w-3xl mx-auto">
              N'attendez pas les derniers instants pour réserver ! La photographie de naissance se réalise idéalement dans les 10 premiers jours de vie de bébé et au plus tard jusqu'à 1 mois dans un cocon calme et sécurisé.
            </p>
            <Link to="/contact">
              <Button className="bg-[#8B7355] hover:bg-[#6B5845] text-white font-body px-8 py-6 text-base rounded-lg btn-primary mt-6">
                Réserver maintenant
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="rounded-lg shadow-lg overflow-hidden service-card">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/3rv4qk4x_4N9A5734.jpg" 
                alt="Photo naissance Haguenau - Parents avec nouveau-né" 
                className="w-full h-[500px] object-cover object-center"
              />
            </div>
            <div className="rounded-lg shadow-lg overflow-hidden service-card">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/rnbn4qbk_81950939-3D9C-4EC4-B8E4-632C76F408F4.JPEG" 
                alt="Photographe nouveau-né Strasbourg - Bébé endormi" 
                className="w-full h-[500px] object-cover object-center"
              />
            </div>
            <div className="rounded-lg shadow-lg overflow-hidden service-card">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/26pzbo2f_4N9A2582.jpg" 
                alt="Séance photo famille Haguenau" 
                className="w-full h-[500px] object-cover object-center"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Instagram CTA Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="font-heading text-3xl font-semibold text-[#6B5845]">
            Suivez nos créations sur Instagram
          </h2>
          <p className="font-body text-base text-[#6B5845] leading-relaxed">
            Découvrez nos dernières séances photo maternité et naissance, nos coulisses et bien plus encore !
          </p>
          <a 
            href="https://www.instagram.com/yastudio_photography/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button className="bg-gradient-to-r from-[#E1306C] to-[#FD1D1D] hover:opacity-90 text-white font-body px-8 py-6 text-base rounded-lg btn-primary inline-flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>Suivez-nous sur Instagram</span>
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default Naissance;